<template>
  <div class="tickets">
    
  </div>
</template>